var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtaIconsDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16.001,
    viewBox: "0 0 14 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5-13H9.75l-.294-.584A.75.75,0,0,0,8.784-14s0,0,0,0H5.21a.74.74,0,0,0-.666.416L4.25-13H.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,13.5-13ZM1.663.594A1.5,1.5,0,0,0,3.159,2h7.681a1.5,1.5,0,0,0,1.5-1.406L13-10H1Z",
    transform: "translate(0 14.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaIconsDelete);
export default __webpack_public_path__ + "static/media/ctaIcons_Delete.bd1165b1.svg";
export { ForwardRef as ReactComponent };